// Note: These should match the values set in scss. Currently it is a manual process to keep them in sync
var breakPoints = {
  navBar: 600,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1800,
};
